import { closeSnackbar, enqueueSnackbar } from "notistack";


export const showNotification = (message: string, options: any) => {
  enqueueSnackbar(message, options)
};

export const closeNotification = (key: any) => {
  closeSnackbar(key)
};

